export const _en = {
    addButton: {
        label: "Add a new profile"
    },
    toggleDeleted: {
        label: "Show deleted data"
    },
    dialog: {
        add: {
            title: "Add a new profile",
            buttons: {
                save: "Save",
                cancel: "Cancel"
            }
        }
    },
    table: {
        header: {
            page: "page",
            access: {
                read: "Read",
                deny: "Deny",
                write: "Write"
            }
        }
    }
};


export const _fr = {
    addButton: {
        label: "Nouveau profil"
    },
    toggleDeleted: {
        label: "Afficher les profils supprimés"
    },
    dialog: {
        add: {
            title: "Ajouter un profil",
            buttons: {
                save: "Sauvegarder",
                cancel: "Annuler"
            }
        }
    },
    table: {
        header: {
            page: "Page",
            access: {
                read: "Lecture",
                deny: "Interdit",
                write: "Écriture"
            }
        }
    }
};